import { useTranslation } from 'react-i18next';

import { Skeleton } from '@/components/ui/skeleton';

/**
 * Shown while a lazily-loaded route chunk downloads.
 *
 * A skeleton in the shape of the page rather than a centred spinner: it keeps the
 * layout from shifting when content arrives, and it reads as "this is loading"
 * rather than "this is stuck" on the slower branch connections the kiosk and
 * counter terminals run on.
 */
export function RouteFallback() {
    const { t } = useTranslation('common');

    return (
        <div className="space-y-6" role="status" aria-busy="true">
            <span className="sr-only">{t('state.loading')}</span>

            <div className="space-y-2">
                <Skeleton className="h-7 w-56" />
                <Skeleton className="h-4 w-80" />
            </div>

            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {Array.from({ length: 4 }).map((_, index) => (
                    <Skeleton key={index} className="h-24 rounded-lg" />
                ))}
            </div>

            <Skeleton className="h-72 rounded-lg" />
        </div>
    );
}
